export const GET_HOME_BANNER = "GET_HOME_BANNER";
export const GET_HOME_BANNER_LOADING = "GET_HOME_BANNER_LOADING";

export const GET_COMMON_BANNER = "GET_COMMON_BANNER";
export const GET_COMMON_BANNER_LOADING = "GET_COMMON_BANNER_LOADING";
